/* eslint-disable */

import './slideToggle.min';

/**
 *
 */
export default function () {

	// breakpoint conditions
	//
	let viewportWidth;
	/**
	 *
	 */
	const setViewportWidth = function () {

		viewportWidth = window.innerWidth || document.documentElement.clientWidth;

	}
	setViewportWidth();

	/**
	 *
	 */
	function dropdownTiles() {

		const parent = document.querySelectorAll( '.js-dropTile' );

		parent.forEach( function ( element ) {

			const collapse = element.querySelector( '.js-dropTile_collapse' );
			const toggle = element.querySelector( '.js-dropTile_toggle' );

			element.addEventListener( 'mouseenter', () => {

				if ( viewportWidth > 1024 ) {

					collapse.slideDown( 300 );
					element.classList.add( 'open' );

				}

			} );

			element.addEventListener( 'mouseleave', () => {

				if ( viewportWidth > 1024 ) {

					collapse.slideUp( 200 );
					setTimeout( function () {

						element.classList.remove( 'open' );

					}, 200 );

				}

			} );

			/**
			 *
			 */
			toggle.onclick = function () {

				if ( viewportWidth <= 1024 ) {

					collapse.slideToggle( 300 );
					element.classList.toggle( 'open' );

				}

			}

		} );

	}

	dropdownTiles();

	// on resize recalculate vw and run relevant functions
	//
	window.addEventListener( 'resize', function () {

		setViewportWidth();
		dropdownTiles();

	}, false );

}
